module.exports = __webpack_public_path__ + "static/resource-2-b733701a66604c04ad6e6dcf01eb98e3.png";